import { IndexModel } from "../Support/IndexModel";
export class ReportIndex extends IndexModel {
    endpoint = 'report';
    getData() {
        return super.getData();
    }
}
